import{_ as a}from"./_assocIndexOf.js";var r=a;var _=function(a){return r(this.__data__,a)>-1};export{_};
